import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import SupportRightContent from '@/components/SupportCommon/SupportRightContent';
import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import Tabs from '@/components/UI/Tabs';
import { useGlobal } from '@/utils/useGlobal';
import { Popover } from 'antd';
import { useMemo } from 'react';
import css from './accessories.module.scss';
import { IProductData, ISpuData, useAccessoriesData } from './with';
export default function AccessoriesPC({ lang, categoryList }: { lang: any; categoryList: IProductData[] }) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');

    const { AccessoriesData, AccessoriesHandle } = useAccessoriesData(categoryList);
    const { tabList, productData, productContent, active, visible, currentSpu } = AccessoriesData;
    const { setVisible, handleChoose, handleSearch, handleChangeTab } = AccessoriesHandle;

    const PopoverHTML = useMemo(() => {
        return (
            <div className="content">
                <div className="product">
                    <ul>
                        {productData.map((item: IProductData, index: number) => (
                            <li key={index}>
                                <h4>{item.name}</h4>
                                <div className="itemsList">
                                    {item.children?.map((list: ISpuData) => (
                                        <span
                                            key={list.spuId + list.name}
                                            className={currentSpu?.spuId === list.spuId ? 'active' : ''}
                                            onClick={() => handleChoose(list)}
                                        >
                                            {list.name}
                                        </span>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="product category">
                    <a onClick={handleSearch} arial-label={lang.site_product_accessories_ok}>
                        <Button type="primary" arial-label={lang.site_product_accessories_ok} className="round default-btn small hide-btn">
                            {lang.site_product_accessories_ok}
                        </Button>
                    </a>
                </div>
            </div>
        );
    }, [productData, currentSpu]);

    const proListHTML = useMemo(() => {
        if (productContent && productContent.length > 0) {
            return <SupportRightContent content={productContent} />;
        }
        return (
            <div className="noData">
                <Image src="/img/nodata.png" layout="fill" className="fullImgs" />
                <div className="nodataText">{t('accessory.nodata')}</div>
            </div>
        );
    }, [productContent]);

    return (
        <div className={`${css.accessories} container`}>
            <h1 className="title">{lang.site_product_accessories}</h1>
            <div className="accessories-box">
                <div className="content">
                    <div className="left">
                        <Tabs tabPosition={'top'} className="default-tabs font-family-semibold" data={tabList} activeKey={active} onChange={handleChangeTab} />
                    </div>
                    <div className="right">
                        <Popover
                            overlayClassName={css.dropDownMenu}
                            content={PopoverHTML}
                            trigger="click"
                            placement="bottomRight"
                            visible={visible}
                            onVisibleChange={(val) => setVisible(val)}
                        >
                            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()} arial-label={lang.site_product_accessories_browse}>
                                {lang.site_product_accessories_browse}
                                <span style={{ marginLeft: '9px' }} className={visible ? 'imgs' : ''}>
                                    {/* 下面这行不注释掉，会报错，阻碍整个页面运行 */}
                                    <EFArrowDown style={{ fontSize: '12px', transition: 'all .3s' }} />
                                </span>
                            </a>
                        </Popover>
                    </div>
                </div>
                <div className="proList">{proListHTML}</div>
            </div>
            <SupportContactUs isShow={true} nodata={!productContent?.length} />
        </div>
    );
}
